/* eslint-disable jsx-quotes */
import React from 'react';
import MetaSeo from '../MetaSeo';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import useTrans from '@/hooks/useTrans';
import BreadcrumbComponent from '../Other/BreadCrumbComponent';
import TextFooter from '../TextFooter';
import AppDownload from '../Common/AppDownload';
import AboutHNG from '../Common/AboutHNG';
import styles from './appmobile.module.css';

const Mobile = ({ title_seo, description, text_footer }) => {
  const trans = useTrans();

  const scrollReg = () => {
    const element = document.getElementById('aff_sign_up');
    element.scrollIntoView();
  };

  const dataSeo = {
    title: title_seo || 'Ứng Dụng HanaGold',
    description: description || '',
    image: 'https://hanagold.vn/assets/img/aff/bg_seo_a.png?t=1',
    url: 'https://hanagold.vn/app-mua-vang-online',
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className="aff_slider">
        <div>
          <div className={`aff_slider-image ${styles["mobile_slider-image"]}`}>
            <div className="content_text" data-aos="fade-down">
              <div className='aff_breadcrumb_component'>
                <BreadcrumbComponent title='Ứng dụng di động' url='app-mua-vang-online'/>
              </div>
              <h1>{trans?.mobile_app?.title}</h1>
              <div>
                <h2>{trans?.mobile_app?.title_b}</h2>
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: trans?.mobile_app?.title_c,
                }}
              ></p>
              <div className="aff_btn_res">
                <a
                  onClick={e => {
                    e.preventDefault();
                    scrollReg();
                  }}
                >
                  {' '}
                  {trans?.mobile_app?.btn_a}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["mobile_intro"]}>
        <div className={styles["mobile_intro_container"]}>
          <div className={styles["mobile_intro_content"]}>
            <div className={styles["mobile_l"]} data-aos="fade-right">
              <img
                src="/assets/img/aff/mb_i.png?t=1"
                alt=""
                className="lazyload"
              />
            </div>
            <div className={styles["mobile_r"]} data-aos="fade-left">
              <h2 className={styles['sub-title']}>{trans?.mobile_app?.intro}</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: trans?.mobile_app?.intro_des,
                }}
              ></p>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles["mobile_benefit"]} ${styles["mobile_benefit_dt"]}`}>
        <div className={styles["mobile_benefit_container"]}>
          <div className={styles["mobile_benefit_content"]}>
            <div className={styles["mobile_benefit_t"]}>
              <h2 className={styles['sub-title']}>{trans?.mobile_app?.benefit}</h2>
            </div>
            <div className={styles["mobile_benefit_l"]}>
              <div className={styles["item_be"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/be_a.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_a}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_a,
                    }}
                  ></p>
                </div>
              </div>

              <div className={styles["item_be"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/be_b.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_b}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_b,
                    }}
                  ></p>
                </div>
              </div>

              <div className={styles["item_be"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/be_c.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_c}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_c,
                    }}
                  ></p>
                </div>
              </div>
            </div>

            <div className={styles["mobile_benefit_b"]}>
              <div className={styles["item_be"]} data-aos="fade-up">
                <img
                  src="/assets/img/aff/be_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_d}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_d,
                    }}
                  ></p>
                </div>
              </div>
            </div>

            <div className={styles["mobile_benefit_r"]}>
              <div className={styles["item_be"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/be_h.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_e}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_e,
                    }}
                  ></p>
                </div>
              </div>
              <div className={styles["item_be"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/bg_g.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_f}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_f,
                    }}
                  ></p>
                </div>
              </div>
              <div className={styles["item_be"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/be_e.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_g}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_g,
                    }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles["mobile_benefit"]} ${styles["mobile_benefit_mb"]}`}>
        <div className={styles["mobile_benefit_container"]}>
          <div className="">
            <div className={styles["mobile_benefit_t"]} data-aos="fade-down">
              <h2 className={styles['sub-title']}>{trans?.mobile_app?.benefit}</h2>
            </div>
            <div className={styles["mobile_benefit_l"]}>
              <div className={styles["item_be"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/be_a.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_a}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_a,
                    }}
                  ></p>
                </div>
              </div>
              <div className={styles["item_be"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/be_b.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_b}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_b,
                    }}
                  ></p>
                </div>
              </div>
              <div className={styles["item_be"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/be_h.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_e}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_e,
                    }}
                  ></p>
                </div>
              </div>
              <div className={styles["item_be"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/bg_g.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_f}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_f,
                    }}
                  ></p>
                </div>
              </div>
            </div>

            <div className={styles["mobile_benefit_b"]} data-aos="fade-in">
              <img
                src="/assets/img/aff/be_m_m.png"
                alt=""
                className="lazyload"
              />
            </div>

            <div className={styles["mobile_benefit_r"]}>
              <div className="item_be" data-aos="fade-left">
                <img
                  src="/assets/img/aff/be_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_d}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_d,
                    }}
                  ></p>
                </div>
              </div>
              <div className={styles["item_be"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/be_e.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_g}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_g,
                    }}
                  ></p>
                </div>
              </div>
              <div className={styles["item_be"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/be_c.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans?.mobile_app?.benefit_t_c}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: trans?.mobile_app?.benefit_d_c,
                    }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className={`${styles["mobile_fearture"]} ${styles["mobile_fearture_dt"]}`}>
        <div className={styles["mobile_fearture_container"]}>
          <div className={styles["mobile_fearture_content"]}>
            <h2 className={styles['sub-title']}>{trans.mobile_app.feature}</h2>
            <div className={styles["mb_items_l"]}>
              <div className={styles["mb_item"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/fr_a_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_a}</h3>
                  <p>{trans.mobile_app.feature_d_a}</p>
                </div>
              </div>

              <div className={styles["mb_item"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/fr_b_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h6>{trans.mobile_app.feature_t_b}</h6>
                  <p>{trans.mobile_app.feature_d_b}</p>
                </div>
              </div>

              <div className={styles["mb_item"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/fr_c_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_c}</h3>
                  <p>{trans.mobile_app.feature_d_c}</p>
                </div>
              </div>
            </div>
            <div className={styles["mb_items_r"]}>
              <div className={styles["mb_item"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/fr_d_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_d}</h3>
                  <p>{trans.mobile_app.feature_d_d}</p>
                </div>
              </div>

              <div className={styles["mb_item"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/fr_e_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_e}</h3>
                  <p>{trans.mobile_app.feature_d_e}</p>
                </div>
              </div>
              <div className={styles["mb_item"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/fr_f_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_f}</h3>
                  <p>{trans.mobile_app.feature_d_f}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles["mobile_fearture"]} ${styles["mobile_fearture_mb"]}`}>
        <div className="">
          <div className={styles["mobile_fearture_content"]}>
            <h2 className={styles['sub-title']}>{trans.mobile_app.feature}</h2>

            <img
              src="/assets/img/aff/dt_mb.png?t=1"
              alt=""
              className="lazyload"
            />
            <div className={styles["mb_items_r"]}>
              <div className={styles["mb_item"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/fr_d.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_d}</h3>
                  <p>{trans.mobile_app.feature_d_d}</p>
                </div>
              </div>

              <div className={styles["mb_item"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/fr_e.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_e}</h3>
                  <p>{trans.mobile_app.feature_d_e}</p>
                </div>
              </div>
              <div className={styles["mb_item"]} data-aos="fade-right">
                <img
                  src="/assets/img/aff/fr_f.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_f}</h3>
                  <p>{trans.mobile_app.feature_d_f}</p>
                </div>
              </div>
            </div>

            <div className={styles["mb_items_l"]}>
              <div className={styles["mb_item"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/fr_a.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_a}</h3>
                  <p>{trans.mobile_app.feature_d_a}</p>
                </div>
              </div>

              <div className={styles["mb_item"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/fr_b.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_b}</h3>
                  <p>{trans.mobile_app.feature_d_b}</p>
                </div>
              </div>

              <div className={styles["mb_item"]} data-aos="fade-left">
                <img
                  src="/assets/img/aff/fr_c.svg"
                  alt=""
                  className="lazyload"
                />
                <div>
                  <h3>{trans.mobile_app.feature_t_c}</h3>
                  <p>{trans.mobile_app.feature_d_c}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["mobile_tech"]}>
        <div className={styles["mobile_tech_container"]}>
          <div className={styles["mobile_tech_content"]} data-aos="fade-down">
            <h2 className={styles['sub-title']}>{trans?.mobile_app.tech}</h2>
            <h3 className={styles['sub-title-2nd']}>{trans?.mobile_app.tech_a}</h3>
            <div>
              <img
                src="/assets/img/aff/mt_img.svg"
                alt=""
                className="lazyload"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles["mobile_nfc"]}>
        <div className={styles["mobile_nfc_container"]}>
          <div className={styles["mobile_nfc_content"]}>
            <div>
              <img
                className={`${styles["mb_nfc"]} lazyload`}
                src="/assets/img/aff/mb_nfc.png"
                alt=""
              />
              <img
                className={`${styles["mb_nfc_m"]} lazyload`}
                src="/assets/img/aff/mb_nfc_m.png"
                alt=""
              />
            </div>
            <div className={styles["jsanvbbsad"]}>
              <h2>{trans.mobile_app.save}</h2>
              <h3>{trans.mobile_app.save_a}</h3>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["mobile_experience"]}>
        <div className={styles["mobile_experience_container"]}>
          <div className={styles["mobile_experience_content"]}>
            <div className={styles["mobile_experience_t"]} data-aos="fade-down">
              <h2>{trans.mobile_app.feeling}</h2>
              <h3>{trans.mobile_app.feeling_a}</h3>
            </div>
            <div className={styles["mobile_experience_slide"]} data-aos="fade-in">
              <div>
                <Swiper
                  breakpoints={{
                    // when window width is >= 640px
                    975: {
                      slidesPerView: 2,
                      spaceBetween: 40,
                    },
                    // when window width is >= 768px
                  }}
                  spaceBetween={40}
                  slidesPerView={1}
                  loop={{
                    loop: true,
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{
                    delay: 3000,
                    speed: 2000,
                  }}
                  modules={[Pagination, Autoplay]}
                  className="mySwiperApp"
                >
                  <SwiperSlide>
                    {' '}
                    <div className="item_share_card">
                      <div className="text_card_s">
                        <img
                          src="/assets/img/aff/sym.svg"
                          alt=""
                          className="sys lazyload"
                        />
                        <p>
                          Là một người đại diện cho thế hệ đổi mới thì Ngân rất
                          mong muốn và ủng hộ những mô hình khởi nghiệp kinh
                          doanh đổi mới, tân tiến trong quá trình cập nhật công
                          nghệ hiện đại. Hy vọng HanaGold sẽ tìm được cho mình
                          một con đường rất mới và một con đường phát triển bền
                          vững cùng với năm tháng và cùng với nhu cầu của khách
                          hàng.
                        </p>
                      </div>
                      <div className="item_share_card_f">
                        <img
                          src="/assets/img/aff/c_a.png"
                          alt=""
                          className="lazyload"
                        />
                        <div>
                          <p>Ms. Ninh Hoàng Ngân</p>
                          <div className={styles["mobile_experience_a"]}>
                            <span>Hoa hậu</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    {' '}
                    <div className="item_share_card">
                      <div className="text_card_s">
                        <img
                          src="/assets/img/aff/sym.svg"
                          alt=""
                          className="sys "
                        />
                        <p>
                          HanaGold đã giúp cho rất nhiều người sẽ hiểu được ý
                          nghĩa của việc ứng dụng công nghệ trong việc sở hữu và
                          kinh doanh vàng. Và cũng như giúp cho nhiều người Việt
                          Nam có một giải pháp để có thể tích luỹ tài sản. Cũng
                          như đảm bảo được việc tích trữ lâu dài và hiệu quả.
                        </p>
                      </div>
                      <div className="item_share_card_f">
                        <img
                          src="/assets/img/aff/c_b.png"
                          alt=""
                          className="lazyload"
                        />
                        <div>
                          <p>Mr. Quốc Cường</p>
                          <div className={styles["mobile_experience_a"]}>
                            <span>Đối tác HanaGold</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    {' '}
                    <div className="item_share_card">
                      <div className="text_card_s">
                        <img src="/assets/img/aff/sym.svg" className="sys " />
                        <p>
                          Rất là bất ngờ khi thấy cửa hàng rất là khang trang và
                          cái giải pháp mà HanaGold đưa ra nó cũng rất là phù
                          hợp. Mình nghĩ đây cũng là một cái xu hướng mà trong
                          những năm tới sẽ cực kỳ phổ biến.
                        </p>
                      </div>
                      <div className="item_share_card_f">
                        <img
                          src="/assets/img/aff/c_c.png"
                          alt=""
                          className="lazyload"
                        />
                        <div>
                          <p>Mr. Tony Tuyên</p>
                          <div className={styles["mobile_experience_a"]}>
                            <span>Founder & CMO FCIHUB, Golden Forest</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    {' '}
                    <div className="item_share_card">
                      <div className="text_card_s">
                        <img src="/assets/img/aff/sym.svg" className="sys " />
                        <p>
                          HanaGold là đơn vị tiên phong trong lĩnh vực vàng kỹ
                          thuật số, thể hiện được sự chuyên nghiệp trong quá
                          trình ra mắt sản phẩm, mẫu mã. Đặc biệt công nghệ
                          HanaGold càng ngày càng cải thiện hơn, nâng cấp hơn.
                        </p>
                      </div>
                      <div className="item_share_card_f">
                        <img
                          src="/assets/img/aff/c_d.png"
                          alt=""
                          className="lazyload"
                        />
                        <div>
                          <p>Ms. Lan Anh</p>
                          <div className={styles["mobile_experience_a"]}>
                            <span>Giám đốc công ty TNHH Kim Tín Phát</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    {' '}
                    <div className="item_share_card">
                      <div className="text_card_s">
                        <img
                          src="/assets/img/aff/sym.svg"
                          alt=""
                          className="sys ladyload"
                        />
                        <p>
                          Ở Việt Nam, ai cũng ngắm đến vàng nhưng mà vàng 4.0
                          thì chị thấy đây là lần đầu tiên HanaGold thực hiện
                          cái công nghệ mới này. Và đặc biệt là cái cách phát
                          triển rất là chuyên nghiệp. Nên là chị cảm thấy
                          HanaGold là một nơi đáng tin cậy, có tầm nhìn - Chiến
                          lược - Định hướng mạnh mẽ.
                        </p>
                      </div>
                      <div className="item_share_card_f">
                        <img
                          src="/assets/img/aff/c_e.png"
                          alt=""
                          className="lazyload"
                        />
                        <div>
                          <p>Ms. Hồng</p>
                          <div className={styles["mobile_experience_a"]}>
                            <span>Đại diện công ty Rừng Vàng</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    {' '}
                    <div className="item_share_card">
                      <div className="text_card_s">
                        <img
                          src="/assets/img/aff/sym.svg"
                          alt=""
                          className="sys lazyload"
                        />
                        <p>
                          Một doanh nghiệp đang tiên phong với những cái công
                          nghệ, sản phẩm rất là đổi mới, đi đầu về số. Hy vọng
                          HanaGold sẽ tiếp tục phát triển mạng lưới của phủ rộng
                          khắp toàn quốc. Ra nhiều sản phẩm hơn nữa về công
                          nghệ, để dẫn đầu xu thế như hiện nay.
                        </p>
                      </div>
                      <div className="item_share_card_f">
                        <img
                          src="/assets/img/aff/c_f.png"
                          alt=""
                          className="lazyload"
                        />
                        <div>
                          <p>Mr. Thanh Tùng</p>
                          <div className={styles["mobile_experience_a"]}>
                            <span>Phó giám đốc trung tâm thẻ HDbank</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AboutHNG />

      <AppDownload is_home={false}/>

      <TextFooter text={text_footer}/>
    </>
  );
};

export default Mobile;
